(function () {
  var nav = document.querySelector('.pdp-stick-tabs');
  if (!nav) return;

  // Tab click → smooth scroll to panel
  document.querySelectorAll('[data-target]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var targetId = btn.getAttribute('data-target');
      var target = document.getElementById(targetId);
      if (!target) return;
      var navH = nav.offsetHeight + 96 + 16;
      var top = target.getBoundingClientRect().top + window.pageYOffset - navH;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  // IntersectionObserver — highlight active tab as user scrolls
  var panels = document.querySelectorAll('[id^="tab-"]');
  var btns   = document.querySelectorAll('[data-target]');
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        btns.forEach(function (b) { b.classList.remove('is-active'); });
        var active = document.querySelector('[data-target="' + e.target.id + '"]');
        if (active) active.classList.add('is-active');
      }
    });
  }, { rootMargin: '-10% 0px -80% 0px' });
  panels.forEach(function (p) { observer.observe(p); });
})();
